// extracted by mini-css-extract-plugin
module.exports = {"content":"search_content__YbXc8","box":"search_box__XDCcG","header":"search_header__tK4EX","body":"search_body__SkUFQ","inner":"search_inner__fD4E9"};